import '../../resources/css/maintenance/ModelForm.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Button, Row, Col } from 'react-bootstrap';
import { commonRenderInput, commonRenderCheckbox } from '../../components/common/access-form';
import { verifyForm, maxLength20, verifyNumber, verifyUpperLetter, max10, verifyWebUrl } from '../../components/common/access-form-validation';
import { forwardModelList, saveModelForm, SAVE_MODEL_FORM_SUCCESS, SAVE_MODEL_FORM_FAIL, WAIT_INIT_MODELS, setModeDetail } from '../../actions/maintenance/index.js';
import Loading from '../../components/common/Loading';


class ModelForm extends Component {

    formSubmit = (values) => {
        const { idToken, match, saveModelForm } = this.props;
        const formType = match.params.formType;

        let type;
        switch (formType) {
            case 'addModel':
                type = 'NEW';                
                break;
            case 'editModel':
                type = 'EDIT';
                break;
            default:
                console.error('formType is config error.');
        }

        const reqBodyObj = {
            modelName: values.modelName,
            maxFanSpeed: parseInt(values.fanMax),
            maxLightLevel: parseInt(values.lightMax),
            GreaseFilterVideoURL: values.GreaseFilterVideoURL,
            UserManualURL: values.UserManualURL,
            ProductPhotoURL: values.ProductPhotoURL,
            PartsWarranty: parseInt(values.PartsWarranty),
            LaborWarranty: parseInt(values.LaborWarranty),
            steamClean: values.steamClean ? 1 : 0 ,
            airQuality: values.airQuality ? 1 : 0
        };

        saveModelForm(type, idToken, reqBodyObj);
    }

    checkSteamClean = (e) => {
        const { formValues, change } = this.props;
        const doCheck = formValues.steamClean !== 1 ? 1 : 0;
        change('steamClean', doCheck);
    }

    checkAirQuality = (e) => {
        const { formValues, change } = this.props;
        const doCheck = formValues.airQuality !== 1 ? 1 : 0;
        change('airQuality', doCheck);
    }

    componentDidMount() {
        const { status, setModeDetail } = this.props;

        if (status === WAIT_INIT_MODELS) {
            // it's init devices page status, so it's refrsh page
            const modelDetailParams = JSON.parse(window.sessionStorage.getItem('RangeHood.' + window.CONFIG.CACHE_MODEL));
            if (modelDetailParams) {
                setModeDetail(modelDetailParams.modelDetail);
            }            
        }
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        const { status, history, errMsg, forwardModelList } = this.props;

        if (prevProps.status !== status) {
            // init do init
            if (status === SAVE_MODEL_FORM_SUCCESS) {
                forwardModelList();
                history.goBack();
            }

            if (status === SAVE_MODEL_FORM_FAIL) {
                if (errMsg) {
                    alert(errMsg);
                }
            }
        }
    }

    render() {
        const { handleSubmit, verifyFormPass, pkReadOnly, readOnly, loading, match, saveLoading } = this.props;
        let formTitle = '';
        let btnSubmit = (
            <Row>
                <Col md={2} xl={4}>&nbsp;</Col>
                <Col md={8} xl={4}>
                    <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>Save</Button>
                </Col>
                <Col md={2} xl={4}>&nbsp;</Col>
            </Row>
        );

        if (match.params['formType'] === 'addModel') {
            // is add model
            // so not load detail data into form
            formTitle = 'Add a hood model';

        } else {
            // load data into form
            // check is data loading?
            if (loading) {
                return (
                    <Loading loading={true}></Loading>
                );
            }

            if (match.params['formType'] === 'editModel'){
                // edit form
                formTitle = 'Edit hood model';
            } else {
                // view form
                formTitle = 'Info';
                btnSubmit = (<div className="text-align-c"></div>);
            }
        }
        
        return (
            <div className="model-form form-custom">
                <div className='form-title'>{formTitle}</div>
                <form onSubmit={handleSubmit(this.formSubmit)}>
                    <Field name="modelName" type="text" component={commonRenderInput} label="Model Number" need={true} validate={[verifyUpperLetter, maxLength20]}
                        placeholder="Please input model number" subLabel="(Max. 20 letters and uppercase)" disabled={pkReadOnly} />

                    <label className='form-sub-title'>Control</label>
                    <Field name="fanMax" type="text" component={commonRenderInput} label="Max. Fan Speed" need={true} validate={[verifyNumber, max10]}
                        placeholder="Please input maximum fan speed level" subLabel="(Max: 10)" disabled={readOnly} />
                    <Field name="lightMax" type="text" component={commonRenderInput} label="Max. Lighting Level" need={true}  validate={[verifyNumber, max10]} 
                        placeholder="Please input maximum light level" subLabel="(Max: 10)" disabled={readOnly} />
                    {/* <Field name="greaseFilterMaxTime" type="text" component={commonRenderInput} label="Grease Filter Life" need={true} 
                        placeholder="Please input maximum number of hours it can be used" validate={verifyNumber} subLabel="(hours)" disabled={readOnly} />
                    <Field name="charcoalFilterMaxTime" type="text" component={commonRenderInput} label="Charcoal Filter Life" need={true} 
                        placeholder="Please input maximum number of hours it can be used" validate={verifyNumber} subLabel="(hours)" disabled={readOnly} /> */}
                    <Field name="steamClean" label="Steam Clean" callback={this.checkSteamClean} component={commonRenderCheckbox} disabled={readOnly} />
                    <Field name="airQuality" label="Air Quality" callback={this.checkAirQuality} component={commonRenderCheckbox} disabled={readOnly} />

                    <label className='form-sub-title'>Warranty</label>
                    <Field name="PartsWarranty" type="text" component={commonRenderInput} label="Parts Warranty" need={true} validate={[verifyNumber]}
                        placeholder="Please input parts warranty" subLabel="(measured in months)" disabled={readOnly} />
                    <Field name="LaborWarranty" type="text" component={commonRenderInput} label="Labor Warranty" need={true} validate={[verifyNumber]}
                        placeholder="Please input labor warranty" subLabel="(measured in months)" disabled={readOnly} />

                    <label className='form-sub-title'>Web Url</label>
                    {/* <Field name="GreaseFilterWebstoreURL" type="text" component={commonRenderInput} label="Grease Filter Webstore Link" need={true} validate={verifyWebUrl}
                        placeholder="Please input grease filter webstore link" disabled={readOnly} />
                    <Field name="CharcoalFilterWebstoreURL" type="text" component={commonRenderInput} label="Charcoal Filter Webstore Link" need={true} validate={verifyWebUrl}
                        placeholder="Please input charcoal filter webstore link" disabled={readOnly} /> */}
                    {/* <Field name="HoodCleanVideoURL" type="text" component={commonRenderInput} label="General Hood Cleaning Video Link" need={true} validate={verifyWebUrl}
                        placeholder="Please input general hood cleaning video link" disabled={readOnly} /> */}
                    <Field name="GreaseFilterVideoURL" type="text" component={commonRenderInput} label="Steam Cleaning Video Link" need={true} validate={verifyWebUrl}
                        placeholder="Please input grease filter cleaning video link" disabled={readOnly} />
                    {/* <Field name="CharcoalFilterVideoURL" type="text" component={commonRenderInput} label="Charcoal Filter Replacement Video Link" need={true} validate={verifyWebUrl}
                        placeholder="Please input charcoal filter replacement video link" disabled={readOnly} /> */}
                    <Field name="UserManualURL" type="text" component={commonRenderInput} label="User Manual Document Link" need={true} validate={verifyWebUrl}
                        placeholder="Please input user manual document link" disabled={readOnly} />
                    <Field name="ProductPhotoURL" type="text" component={commonRenderInput} label="Product Photo File Link" need={true} validate={verifyWebUrl}
                        placeholder="Please input product photo file link" disabled={readOnly} />
                    { btnSubmit }
                </form>
                <Loading loading={saveLoading} center={true}></Loading>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const modelDetail = state.maintenanceReducers.modelDetail;
    const verifyFormPass = verifyForm(state.form['ModelForm']);

    let ret = {
        idToken: state.logindReducers.idToken,
        status: state.maintenanceReducers.status,
        loading: modelDetail.loading,
        saveLoading: modelDetail.saveLoading,
        readOnly: false,
        pkReadOnly: true,
        verifyFormPass : verifyFormPass,
        errMsg: state.maintenanceReducers.errMsg,
        formValues: getFormValues('ModelForm')(state)
    }

    // set init values to form
    if (!modelDetail.loading) {
        let initialValues = {};
        if (modelDetail && !modelDetail['loading']) {        
            initialValues['modelName'] = modelDetail['modelName'];
            initialValues['fanMax'] = modelDetail['maxFanSpeed'];
            initialValues['lightMax'] = modelDetail['maxLightLevel'];
            // initialValues['greaseFilterMaxTime'] = modelDetail['maxGreasefilterTimer'];
            // initialValues['charcoalFilterMaxTime'] = modelDetail['maxCharcoalfilterTimer'];
            initialValues['PartsWarranty'] = modelDetail['PartsWarranty'];
            initialValues['LaborWarranty'] = modelDetail['LaborWarranty'];
            // initialValues['GreaseFilterWebstoreURL'] = modelDetail['GreaseFilterWebstoreURL'];
            // initialValues['CharcoalFilterWebstoreURL'] = modelDetail['CharcoalFilterWebstoreURL']; 
            // initialValues['HoodCleanVideoURL'] = modelDetail['HoodCleanVideoURL'];
            initialValues['GreaseFilterVideoURL'] = modelDetail['GreaseFilterVideoURL'];
            // initialValues['CharcoalFilterVideoURL'] = modelDetail['CharcoalFilterVideoURL'];
            initialValues['UserManualURL'] = modelDetail['UserManualURL'];
            initialValues['ProductPhotoURL'] = modelDetail['ProductPhotoURL'];
            initialValues['steamClean'] = modelDetail['steamClean'];
            initialValues['airQuality'] = modelDetail['airQuality'];
        }
        
        ret['initialValues'] = initialValues;
    }    

    // set read only in viewModel
    const { formType } = ownProps.match.params;
    if (formType === "addModel") {
        ret['pkReadOnly'] = false;
        let initialValues = {};
        initialValues['steamClean'] = 0;
        initialValues['airQuality'] = 0;
        initialValues['lightMax'] = 2;
        // initialValues['CharcoalFilterWebstoreURL'] = window.CONFIG.DEFAULT_WEB_URL;
        // initialValues['HoodCleanVideoURL'] = window.CONFIG.DEFAULT_WEB_URL;
        initialValues['GreaseFilterVideoURL'] = window.CONFIG.DEFAULT_WEB_URL;
        // initialValues['CharcoalFilterVideoURL'] = window.CONFIG.DEFAULT_WEB_URL;
        ret['initialValues'] = initialValues;
    } else if (formType === "viewModel") {
        ret['readOnly'] = true;  
    }

    return ret;
}

ModelForm = reduxForm({
    form: 'ModelForm',  // a unique identifier for this form
})(ModelForm)
  
export default connect(
    mapStateToProps,
    { forwardModelList, saveModelForm, setModeDetail }
)(ModelForm);